import breadcrumbStyle from "../templates/Breadcrumb.style";
import breadcrumbHzeroStyle from "../templates-hzero/BreadCrumb.style";
var breadcrumbData = {
  name: 'breadcrumb',
  data: [{
    fontSize: 12,
    lastFontSize: 14
  }],
  onlyTemplate: {
    base: breadcrumbStyle,
    hzero: breadcrumbHzeroStyle
  }
};
export default breadcrumbData;